/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file The Plugin Pair Selector component.
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:767.98px){.sym-plugin-pair-selector[_ngcontent-%COMP%]{padding-right:1rem}}.sym-plugin-pair-selector[_ngcontent-%COMP%]   .sym-plugin-pair-selector-part[_ngcontent-%COMP%]{height:43px;border:1px solid #ccc;padding:5px 4px 0}.sym-plugin-pair-selector[_ngcontent-%COMP%]   .sym-plugin-pair-selector-part[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{margin-bottom:4px}"];
export { styles as styles };
